module.exports = __webpack_public_path__ + "img/logo.3aed0699.png";